import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '高速带我文明游 打造美丽风景线';

const route: RouteConfig = {
  path: '/2019GSD',
  name: 'GSD',
  component: () => import('./Home.vue'),
  redirect: '/2019GSD/first',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'first',
      component: () => import('./First.vue'),
      name: 'first',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'second',
      component: () => import('./Second.vue'),
      name: 'second',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'third',
      component: () => import('./Third.vue'),
      name: 'third',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'fourth',
      component: () => import('./Fourth.vue'),
      name: 'fourth',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: 'list',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detailpage',
      component: () => import('./DetailPage.vue'),
      name: 'DetailPage',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
